"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("../errors");
class RenderData {
    constructor(error, data) {
        this.error = error;
        this.data = data;
    }
    static isParseable(payload) {
        const isObject = typeof payload === 'object' && !Array.isArray(payload) && payload !== null;
        if (!isObject)
            return false;
        const record = payload;
        return (typeof record.data === 'object' &&
            !Array.isArray(record.data) &&
            record.data !== null &&
            (record.error === null || errors_1.SentinelError.isParseable(record.error)));
    }
    static parse(encoded) {
        const decoded = Buffer.from(encoded, 'base64').toString('utf8');
        const object = JSON.parse(decoded);
        if (RenderData.isParseable(object)) {
            return new RenderData(object.error, object.data);
        }
        return null;
    }
    static fromParams(searchParams) {
        const encoded = searchParams.get(RenderData.PARAM);
        return encoded ? RenderData.parse(encoded) : null;
    }
    toString() {
        const renderData = {
            error: this.error
                ? {
                    name: this.error.name,
                    message: this.error.message,
                    data: this.error.data,
                }
                : null,
            data: this.data,
        };
        const serialized = JSON.stringify(renderData);
        const encoded = Buffer.from(serialized, 'utf8').toString('base64');
        return encoded;
    }
    toParams() {
        return [RenderData.PARAM, this.toString()];
    }
}
exports.default = RenderData;
RenderData.PARAM = 'rdata';
//# sourceMappingURL=index.js.map